import React, { useEffect, useState } from "react";
import { Checkbox, Form, message } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const, Validations } from "../../../constants";

const langKey = Const["documentType"].lngKey
const formName = "createDocumentType";

const CreateDocumentType = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    setSaveLoader(true)
    const payload = { document_type: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.document_types.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } scrollToFirstError>

        <Form.Item name="name" rules={ rules.name } label={ trans(Commons.name) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="is_required" valuePropName="checked" rules={ rules.is_required } label={ trans(`${langKey}.required`) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_required']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_expiry" valuePropName="checked" rules={ rules.is_expiry } label={ trans(`${langKey}.expiry`) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_expiry']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_multi_attachments" valuePropName="checked" rules={ rules.is_multi_attachments } label={ trans(`${langKey}.multiple`) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_multi_attachments']) } size="small"
        >
          <Checkbox />
        </Form.Item>
        <Form.Item name="is_additional_info" valuePropName="checked" rules={ rules.is_additional_info } label={ trans(`${langKey}.additional`) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_additional_info']) } size="small"
        >
          <Checkbox />
        </Form.Item>

      </Form>
    </ModalComponent>
  )
}

export default CreateDocumentType

const rules = {
  name: [
    { required: true, message: trans(Validations.name) },
  ],

};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}